import styled from 'styled-components';
import { theme, ifProp } from 'styled-tools';

const CTAContainer = styled.section`
  position: absolute;
  top: 0;
  z-index: 10000;

  background: #001947;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
`;

const Header = styled.header`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 90px;
  padding: 0 30px;
  border-bottom: 1px solid ${theme('colors.text.white15')};

  position: fixed;

  > h2 {
    font-family: 'Untitled Sans', serif;
    font-weight: 700;
    font-size: 20px;
    letter-spacing: -0.04em;
    color: white;
  }
`;

const Body = styled.main`
  width: 100%;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  top: 0;
  background: #001947;

  @media (max-width: 620px) {
    padding: 20px;
    height: ${({ height }) => height - 90}px;
  }
`;

const Main = styled.div`
  height: 440px;
  width: 680px;
  border-radius: 20px;
  background: #215988;
  @media (max-width: 620px) {
    height: 100%;
  }
`;

const Content = styled.div`
  height: calc(100% - 70px);
  width: 100%;
  border-radius: 20px;
  background: #003765;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 20px;

  font-family: 'Untitled Sans', serif;

  > h2 {
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    text-align: center;
    letter-spacing: -0.04em;
    color: white;
    @media (max-width: 620px) {
      font-size: 18px;
    }
  }

  > span {
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    text-align: center;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 1);
    &:last-child {
      color: rgba(255, 255, 255, 0.6);
    }
    @media (max-width: 620px) {
      font-size: 11px;
    }
  }
`;

const Footer = styled.footer`
  height: 70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BackButton = styled.button`
  height: 30px;
  width: 150px;
  border-radius: 40px;
  background: #003765;
  border: none;
  font-family: 'Founders Grotesk Mono', serif;
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  text-transform: uppercase;
  color: white;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  @media (max-width: 620px) {
    font-size: 8px;
  }

  ${ifProp(
    'greenButton',
    `
    background: #00F47F;
    color: black;
    `,
  )}
`;

export const S = {
  CTAContainer,
  Header,
  Body,
  Main,
  Content,
  Footer,
  BackButton,
};
